// #1107: exact reference colors from Chemical Color Index, attached to the issue.
// Authored artifact colors use these hex values; accessible UI tones are derived separately.
export const CHEMICAL_PALETTE = [
  {
    id: 'violet',
    name: 'Manganese',
    pigment: 'Manganese Violet',
    formula: 'Mn',
    color: '#9A4EAE',
    group: 'Violet'
  },
  {
    id: 'chromium-chloride-violet',
    name: 'Chromium(III) Chloride',
    pigment: 'Chromium Chloride Violet',
    formula: 'CrCl3',
    color: '#7B4B8A',
    group: 'Violet'
  },
  {
    id: 'permanganate-purple',
    name: 'Potassium Permanganate',
    pigment: 'Permanganate Purple',
    formula: 'KMnO4',
    color: '#7B2D8E',
    group: 'Violet'
  },
  {
    id: 'anthocyanin-magenta',
    name: 'Anthocyanin (Cyanidin)',
    pigment: 'Anthocyanin Magenta',
    formula: 'C15H11O6+',
    color: '#8E2A5B',
    group: 'Violet'
  },
  {
    id: 'indigo-blue',
    name: 'Indigo',
    pigment: 'Indigo Blue',
    formula: 'C16H10N2O2',
    color: '#2E3A6B',
    group: 'Indigo'
  },
  {
    id: 'blue',
    name: 'Cobalt',
    pigment: 'Cobalt Blue',
    formula: 'Co',
    color: '#0047AB',
    group: 'Blue'
  },
  {
    id: 'prussian-blue',
    name: 'Iron-Cyanide Complex',
    pigment: 'Prussian Blue',
    formula: 'Fe4[Fe(CN)6]3',
    color: '#003153',
    group: 'Blue'
  },
  {
    id: 'blue-vitriol',
    name: 'Copper(II) Sulfate Pentahydrate',
    pigment: 'Blue Vitriol',
    formula: 'CuSO4\u00b75H2O',
    color: '#1E73BE',
    group: 'Blue'
  },
  {
    id: 'teal',
    name: 'Basic Copper Acetate',
    pigment: 'Verdigris',
    formula: 'Cu(CH3COO)2\u00b72Cu(OH)2',
    color: '#43B3AE',
    group: 'Green'
  },
  {
    id: 'ferrous-sulfate-green',
    name: 'Ferrous Sulfate (Iron(II) Sulfate)',
    pigment: 'Ferrous Sulfate Green',
    formula: 'FeSO4\u00b77H2O',
    color: '#9CB071',
    group: 'Green'
  },
  {
    id: 'nickel-chloride-green',
    name: 'Nickel(II) Chloride Hexahydrate',
    pigment: 'Nickel Chloride Green',
    formula: 'NiCl2\u00b76H2O',
    color: '#5A9B4E',
    group: 'Green'
  },
  {
    id: 'chlorophyll-green',
    name: 'Chlorophyll a',
    pigment: 'Chlorophyll Green',
    formula: 'C55H72MgN4O5',
    color: '#1B5E3A',
    group: 'Green'
  },
  {
    id: 'fluorescein-green',
    name: 'Fluorescein',
    pigment: 'Fluorescein Green',
    formula: 'C20H12O5',
    color: '#9FE817',
    group: 'Green'
  },
  {
    id: 'chrome-yellow',
    name: 'Chromium',
    pigment: 'Chrome Yellow',
    formula: 'Cr',
    color: '#F5CD00',
    group: 'Yellow'
  },
  {
    id: 'sulfur-yellow',
    name: 'Sulfur',
    pigment: 'Sulfur Yellow',
    formula: 'S8',
    color: '#F2E54C',
    group: 'Yellow'
  },
  {
    id: 'lead-iodide-yellow',
    name: 'Lead(II) Iodide',
    pigment: 'Lead Iodide Yellow',
    formula: 'PbI2',
    color: '#FCD116',
    group: 'Yellow'
  },
  {
    id: 'chromate-yellow',
    name: 'Potassium Chromate',
    pigment: 'Chromate Yellow',
    formula: 'K2CrO4',
    color: '#F4D000',
    group: 'Yellow'
  },
  {
    id: 'amber',
    name: 'Curcumin',
    pigment: 'Curcumin Yellow',
    formula: 'C21H20O6',
    color: '#FEC00F',
    group: 'Yellow'
  },
  {
    id: 'dichromate-orange',
    name: 'Potassium Dichromate',
    pigment: 'Dichromate Orange',
    formula: 'K2Cr2O7',
    color: '#D2491C',
    group: 'Orange'
  },
  {
    id: 'ferric-chloride-brown',
    name: 'Ferric Chloride (Iron(III) Chloride)',
    pigment: 'Ferric Chloride Brown',
    formula: 'FeCl3',
    color: '#8B4A2B',
    group: 'Orange'
  },
  {
    id: 'carotene-orange',
    name: 'Beta-Carotene',
    pigment: 'Carotene Orange',
    formula: 'C40H56',
    color: '#ED8814',
    group: 'Orange'
  },
  {
    id: 'azobenzene-orange',
    name: 'Azobenzene',
    pigment: 'Azobenzene Orange',
    formula: 'C12H10N2',
    color: '#E8720C',
    group: 'Orange'
  },
  {
    id: 'cadmium-red',
    name: 'Cadmium',
    pigment: 'Cadmium Red',
    formula: 'Cd',
    color: '#E30022',
    group: 'Red'
  },
  {
    id: 'lycopene-red',
    name: 'Lycopene',
    pigment: 'Lycopene Red',
    formula: 'C40H56',
    color: '#D8321E',
    group: 'Red'
  },
  {
    id: 'heme-red',
    name: 'Heme B',
    pigment: 'Heme Red',
    formula: 'C34H32FeN4O4',
    color: '#7A1220',
    group: 'Red'
  },
  {
    id: 'cobalt-chloride-pink',
    name: 'Cobalt(II) Chloride Hexahydrate',
    pigment: 'Cobalt Chloride Pink',
    formula: 'CoCl2\u00b76H2O',
    color: '#E8A4C0',
    group: 'Red'
  },
  {
    id: 'manganese-sulfate-pink',
    name: 'Manganese(II) Sulfate',
    pigment: 'Manganese Sulfate Pink',
    formula: 'MnSO4',
    color: '#F6D7D2',
    group: 'Red'
  },
  {
    id: 'phenolphthalein-pink',
    name: 'Phenolphthalein (basic form)',
    pigment: 'Phenolphthalein Pink',
    formula: 'C20H14O4',
    color: '#EE5FA7',
    group: 'Red'
  },
  {
    id: 'aniline-red',
    name: 'Fuchsine (Rosaniline Hydrochloride)',
    pigment: 'Aniline Red',
    formula: 'C20H19N3\u00b7HCl',
    color: '#CA1F7B',
    group: 'Red'
  },
  {
    id: 'platinum',
    name: 'Platinum',
    pigment: 'Platinum',
    formula: 'Pt',
    color: '#E5E4E2',
    group: 'Metallic / Non-Spectral'
  }
] as const;

export type ChemicalColor = (typeof CHEMICAL_PALETTE)[number];
export type ChemicalColorId = ChemicalColor['id'];

export function relativeLuminance(hex: string): number {
  const channels = [1, 3, 5].map((offset) => {
    const value = parseInt(hex.slice(offset, offset + 2), 16) / 255;
    return value <= 0.04045 ? value / 12.92 : ((value + 0.055) / 1.055) ** 2.4;
  });
  return channels[0]! * 0.2126 + channels[1]! * 0.7152 + channels[2]! * 0.0722;
}

export function contrastRatio(a: string, b: string): number {
  const first = relativeLuminance(a),
    second = relativeLuminance(b);
  return (Math.max(first, second) + 0.05) / (Math.min(first, second) + 0.05);
}

export function swatchTextColor(hex: string): '#000000' | '#ffffff' {
  return contrastRatio(hex, '#000000') >= contrastRatio(hex, '#ffffff') ? '#000000' : '#ffffff';
}

export function mixColor(color: string, toward: string, amount: number): string {
  return (
    '#' +
    [1, 3, 5]
      .map((offset) =>
        Math.round(
          parseInt(color.slice(offset, offset + 2), 16) * (1 - amount) +
            parseInt(toward.slice(offset, offset + 2), 16) * amount
        )
          .toString(16)
          .padStart(2, '0')
      )
      .join('')
  );
}

// Preserve the source hue, adjusting brightness only for interface text and controls.
// A 7:1 target on the panel also leaves room for readable text on tinted hover backgrounds.
export function themeTones(color: string) {
  const tone = (background: string, toward: string) => {
    for (let step = 0; step <= 100; step++) {
      const candidate = mixColor(color, toward, step / 100);
      if (contrastRatio(candidate, background) >= 7) return candidate;
    }
    return toward;
  };
  const light = tone('#ffffff', '#000000');
  const dark = tone('#17202a', '#ffffff');
  return {
    light,
    dark,
    lightSoft: mixColor(light, '#ffffff', 0.92),
    darkSoft: mixColor(dark, '#17202a', 0.88),
    primary: tone('#ffffff', '#000000'),
    primaryContrast: '#ffffff'
  };
}
